import {useTranslation} from 'react-i18next'
import {Product, ProductTranslations} from '../../../common/types/product'

// Rule A: if product.translations has any data, the row is the sole source for that product.
// Look up the requested language; fall back to English on the row; finally fall back to the
// internal product field. Products without row data continue to use the i18n bundle via t().
// See doc/product-translations-context.md.
export const useTranslatedProduct = () => {
  const {t} = useTranslation()
  return {
    tDescription: (product: Product, lng?: string): string => {
      if (product.translations) {
        const lang = lng as keyof ProductTranslations | undefined
        const direct = lang ? product.translations[lang]?.description : undefined
        return direct ?? product.translations.en?.description ?? product.description ?? ''
      }
      // @ts-ignore
      return t('products.description.' + product.translationKey, product.description, {lng})
    },
    tName: (product: Product, lng?: string): string => {
      if (product.translations) {
        const lang = lng as keyof ProductTranslations | undefined
        const direct = lang ? product.translations[lang]?.name : undefined
        return direct ?? product.translations.en?.name ?? product.name
      }
      return t('products.name.' + product.translationKey, product.name, {lng})
    },
  }
}
